/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type EducationEventType =
  | 'ES_ADMISSION'
  | 'HS_ADMISSION'
  | 'JHS_ADMISSION'
  | 'UNIV_ADMISSION'
  | 'UNIV_GRADUATION';

export type UserEventType =
  | 'MANDATORY_RETIREMENT'
  | 'THE_PRESENT_TIME';

export type FetchSimpleLifePlanningQueryVariables = Exact<{
  uuid: string | number;
}>;


export type FetchSimpleLifePlanningQuery = { diagnosis: { diagnosisSummary: { simpleLifePlanning: { rows: Array<{ deltaYear: number, remainingAssets: number, monthlyBalance: number, educationCost: number, events: Array<
            | { childLabel: string, educationEventType: Types.EducationEventType }
            | { userEventType: Types.UserEventType }
          > }> } } | null } };


export const FetchSimpleLifePlanningDocument = gql`
    query FetchSimpleLifePlanning($uuid: ID!) {
  diagnosis(uuid: $uuid) {
    diagnosisSummary {
      simpleLifePlanning {
        rows {
          deltaYear
          remainingAssets
          monthlyBalance
          educationCost
          events {
            ... on EducationEvent {
              educationEventType: type
              childLabel
            }
            ... on UserEvent {
              userEventType: type
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchSimpleLifePlanningQuery__
 *
 * To run a query within a Vue component, call `useFetchSimpleLifePlanningQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSimpleLifePlanningQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchSimpleLifePlanningQuery({
 *   uuid: // value for 'uuid'
 * });
 */
export function useFetchSimpleLifePlanningQuery(variables: FetchSimpleLifePlanningQueryVariables | VueCompositionApi.Ref<FetchSimpleLifePlanningQueryVariables> | ReactiveFunction<FetchSimpleLifePlanningQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchSimpleLifePlanningQuery, FetchSimpleLifePlanningQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchSimpleLifePlanningQuery, FetchSimpleLifePlanningQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchSimpleLifePlanningQuery, FetchSimpleLifePlanningQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchSimpleLifePlanningQuery, FetchSimpleLifePlanningQueryVariables>(FetchSimpleLifePlanningDocument, variables, options);
}
export function useFetchSimpleLifePlanningLazyQuery(variables?: FetchSimpleLifePlanningQueryVariables | VueCompositionApi.Ref<FetchSimpleLifePlanningQueryVariables> | ReactiveFunction<FetchSimpleLifePlanningQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchSimpleLifePlanningQuery, FetchSimpleLifePlanningQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchSimpleLifePlanningQuery, FetchSimpleLifePlanningQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchSimpleLifePlanningQuery, FetchSimpleLifePlanningQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchSimpleLifePlanningQuery, FetchSimpleLifePlanningQueryVariables>(FetchSimpleLifePlanningDocument, variables, options);
}
export type FetchSimpleLifePlanningQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchSimpleLifePlanningQuery, FetchSimpleLifePlanningQueryVariables>;